// extracted by mini-css-extract-plugin
export default {"spendeskLogo":"DWhS0Yd5ZYa_pix1PRS_"};